module.exports = __webpack_public_path__ + "media/svg/za-ae8f01fe.svg";